<template>
  <div class="pb50" v-loading="loading">
    <!--用户信息-->
    <div class="common-form mt16">用户信息</div>
    <div class="table-wrap">
      <el-row>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">ID：</span>
            {{ userInfo.user_id }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">昵称：</span>
            {{ userInfo.nickName }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">等级：</span>
            {{ userInfo.grade.name }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">手机：</span>
            {{ userInfo.mobile }}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">推荐人ID：</span>
            {{ userInfo.user_referee.user_id }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">推荐人：</span>
            {{ userInfo.user_referee.nickName }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">推荐人等级：</span>
            {{ userInfo.user_referee.grade.name }}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="pb16">
            <span class="gray9">推荐人手机：</span>
            {{ userInfo.user_referee.mobile }}
          </div>
        </el-col>
      </el-row>    
    </div>
  </div>
  
</template>
<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        userInfo: []
      };
    },
    props: ['user'],
    created() {
      /*获取*/
      this.getUser();
    },
    methods: {
      /*修改用户*/
      getUser() {
        let self = this;
        self.loading = true;
        let params = {user_id : this.user.id};
        UserApi.getuser(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.userInfo = data.data;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },


    }
  };
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/user/structure/part/User.vue